/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { RoutingService } from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import { CurrentItemService } from '../../shared/current-item.service';
import {PermissionService} from "../../../core/services";
import {ROUTE_PARAMS} from "../../../root/route-params";
import {Permission} from "../../../core/model";

@Injectable({
  providedIn: 'root',
})
export class CurrentPermissionService extends CurrentItemService<Permission> {
  constructor(
    protected routingService: RoutingService,
    protected permissionService: PermissionService
  ) {
    super(routingService);
  }

  protected getParamKey() {
    return ROUTE_PARAMS.permissionCode;
  }

  protected getItem(code: string): Observable<Permission> {
    return this.permissionService.get(code);
  }

  getError(code: string): Observable<boolean> {
    return this.permissionService.getErrorState(code);
  }
}
